var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { getGlassDimensions, getRebateDimensions } from './frameDesigner';
/**
 * Validate the rim of a frame can be manufactured
 * @param sku SKU of the length
 * @param rebateSize Rebate size of the frame rim
 * @returns Validation result (promise)
 */
export function validateFrame(sku, rebateSize) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios
            .get('/api/validation/frame/manufacture', {
            params: {
                sku,
                rebateWidth: rebateSize.width,
                rebateLength: rebateSize.length
            }
        });
        return data;
    });
}
/**
 * Validate a mount can be manufactured
 * @param topSku SKU of the top mount
 * @param external External size of the mount
 * @param borders Borders
 * @param bottomSku SKU of the bottom mount
 * @returns Validation result (promise)
 */
export function validateMount(topSku, external, borders, bottomSku = null, revealSize = null) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get('/api/validation/mountboard/manufacture', {
            params: {
                topSku,
                width: external.width,
                length: external.length,
                borderTop: borders.top,
                borderBottom: borders.bottom,
                borderLeft: borders.left,
                borderRight: borders.right,
                bottomSku,
                revealSize
            }
        });
        return data;
    });
}
/**
 * Validate that a sheet can be manufactured to a size
 * @param sku SKU of the sheet
 * @param size Size of the sheet
 * @returns Validation result (promise)
 */
export function validateSheet(sku, size, inFrame = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get('/api/validation/sheets/manufacture', {
            params: {
                sku,
                width: size.width,
                length: size.length,
                inFrame: inFrame ? 1 : 0
            }
        });
        return data;
    });
}
/**
 * Validate a bespoke frame can be manufactured
 * @param item Bespoke frame item
 * @returns Validation result (promise)
 */
export function validateBespokeFrame(item) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
        const promises = [];
        const result = {
            frame: { isValid: true, problems: [], warnings: [] },
            mount: { isValid: true, problems: [], warnings: [] },
            glazing: { isValid: true, problems: [], warnings: [] },
            backing: { isValid: true, problems: [], warnings: [] },
            undermount: { isValid: true, problems: [], warnings: [] },
            fastmount: { isValid: true, problems: [], warnings: [] }
        };
        const rebateDimensions = getRebateDimensions(item.size, item.mount.type != 'none' ? item.mount.borders : null);
        const glassDimensions = getGlassDimensions(rebateDimensions);
        if (item.moulding) {
            promises.push(validateFrame((_a = item.moulding) === null || _a === void 0 ? void 0 : _a.sku, rebateDimensions)
                .then(validation => result.frame = validation));
        }
        else {
            result.frame = { isValid: false, problems: ["You must select a frame moulding to order."], warnings: [] };
        }
        if (item.glazing) {
            promises.push(validateSheet(`${((_b = item.glazing.category) === null || _b === void 0 ? void 0 : _b.name) == 'Acrylic Glass' ? 'A' : ''}G-${item.glazing.id}`, glassDimensions, true).then(validation => result.glazing = validation));
        }
        else if (item.mount.type != 'none') {
            result.glazing = {
                isValid: false,
                problems: ["As you have chosen a mount we require that you choose a glazing option."],
                warnings: []
            };
        }
        if (item.mount.type != 'none') {
            promises.push(validateMount(`MCTS-${(_c = item.mount.top) === null || _c === void 0 ? void 0 : _c.stock_lookup_sku}`, glassDimensions, item.mount.borders, item.mount.type == 'double' ? `MCTS-${(_d = item.mount.bottom) === null || _d === void 0 ? void 0 : _d.stock_lookup_sku}` : null, item.mount.type == 'double' ? item.mount.reveal : null).then(validation => result.mount = validation));
        }
        if (!item.extras.backing && item.glazing != null) {
            result.backing = {
                isValid: false,
                problems: ["As you have chosen a glazing option we require that you have backing board."],
                warnings: []
            };
        }
        if (item.extras.undermount) {
            promises.push(validateSheet(`UM-61`, glassDimensions)
                .then(validation => result.undermount = validation));
        }
        if (item.extras.fastmount) {
            promises.push(validateSheet(`B-58`, glassDimensions)
                .then(validation => result.fastmount = validation));
        }
        yield Promise.all(promises);
        return result;
    });
}
